import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";
import useErrorStore from "store/useErrorStore";

export const Error401 = () => {
  const { setErrorCode } = useErrorStore();
  return (
    <ErrorAlert
      title="Unauthorized."
      errorCode={401}
      buttonTitle="Log In Again"
      onClick={() => {
        setErrorCode(null);
        window.location.href = "/#/login";
      }}
    >
      <p>Please log in to your account again.</p>
    </ErrorAlert>
  );
};
